"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoldReportsReportViewerPage = exports.BoldReportsReportViewerPageActions = void 0;
var boldReportsReportViewerPage_1 = require("./boldReportsReportViewerPage");
exports.BoldReportsReportViewerPage = boldReportsReportViewerPage_1.default;
var boldReportsReportViewerPageActions_1 = require("./boldReportsReportViewerPageActions");
exports.BoldReportsReportViewerPageActions = boldReportsReportViewerPageActions_1.default;
